/* Dormere – DreamHaven pillow page (dk-*). Loaded by every dk section; runs once. */
(() => {
  if (window.__dkPillow) return;
  window.__dkPillow = true;

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const design = !!(window.Shopify && window.Shopify.designMode);
  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    const fmt = (format || '{{amount_with_comma_separator}} €').replace(/<[^>]*>/g, '');
    const value = (Number(cents) || 0) / 100;
    const group = (num, decimals, thousands, dec) => {
      const [int, frac] = num.toFixed(decimals).split('.');
      const i = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? i + dec + frac : i;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return group(value, 2, ',', '.');
        case 'amount_no_decimals': return group(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return group(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(value, 2, "'", '.');
        case 'amount_with_space_separator': return group(value, 2, ' ', ',');
        default: return group(value, 2, '.', ',');
      }
    });
  }

  /* ---------- scrolling helpers ---------- */
  function headerOffset() {
    const h = document.querySelector('sticky-header, .header-section, header');
    if (h) {
      const r = h.getBoundingClientRect();
      if (r.bottom > 0 && r.bottom < 220) return r.bottom + 14;
    }
    return 84;
  }
  function scrollToEl(t) {
    const top = t.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-dk-scroll]');
    if (!a) return;
    const href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    const t = document.getElementById(href.slice(1));
    if (!t) return;
    e.preventDefault();
    scrollToEl(t);
    if (t.matches('[data-dk-tiers]')) {
      t.classList.remove('is-flash');
      void t.offsetWidth;
      t.classList.add('is-flash');
    }
  });

  /* ---------- gallery + lightbox ---------- */
  function initGallery(gal) {
    const track = $('[data-dk-track]', gal);
    if (!track || track.dataset.dkReady) return;
    track.dataset.dkReady = '1';
    const slides = $$('[data-dk-slide]', track);
    const thumbs = $$('[data-dk-thumb]', gal);
    const strip = $('[data-dk-thumbs]', gal);
    const cur = $('[data-dk-cur]', gal);
    let index = 0;
    const go = (i, smooth = true) => {
      if (!slides.length) return;
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth && !reduce ? 'smooth' : 'auto' });
    };
    // Move the thumbnail strip once per change of the active image, and only if its thumbnail is not fully
    // visible. (Restarting a smooth scroll on every scroll frame made it jerk on iPhone.)
    let shown = -1;
    const reveal = () => {
      const th = thumbs[index];
      if (!th || !strip) return;
      const sr = strip.getBoundingClientRect();
      const tr = th.getBoundingClientRect();
      if (tr.left >= sr.left - 1 && tr.right <= sr.right + 1) return;
      const left = strip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2;
      strip.scrollTo({ left: Math.max(0, left), behavior: reduce ? 'auto' : 'smooth' });
    };
    const sync = () => {
      const i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
      index = i;
      if (i === shown) return;
      shown = i;
      if (cur) cur.textContent = String(i + 1);
      thumbs.forEach((t, k) => t.setAttribute('aria-current', k === i ? 'true' : 'false'));
      reveal();
    };
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
    const prev = $('[data-dk-prev]', gal);
    const next = $('[data-dk-next]', gal);
    if (prev) prev.addEventListener('click', () => go(index - 1));
    if (next) next.addEventListener('click', () => go(index + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
    });

    const section = gal.closest('[data-dk-main]');
    const dlg = section && $('[data-dk-lightbox]', section);
    if (!dlg || typeof dlg.showModal !== 'function') return;
    const img = $('[data-dk-lb-img]', dlg);
    const count = $('[data-dk-lb-count]', dlg);
    let li = 0;
    const show = (i) => {
      li = (i + slides.length) % slides.length;
      const s = slides[li];
      const inner = $('img', s);
      img.src = s.dataset.full || (inner && inner.currentSrc) || '';
      img.alt = (inner && inner.alt) || '';
      count.textContent = `${li + 1} / ${slides.length}`;
    };
    slides.forEach((s, k) => s.addEventListener('click', () => { show(k); dlg.showModal(); }));
    $('[data-dk-lb-close]', dlg).addEventListener('click', () => dlg.close());
    $('[data-dk-lb-prev]', dlg).addEventListener('click', () => show(li - 1));
    $('[data-dk-lb-next]', dlg).addEventListener('click', () => show(li + 1));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') show(li + 1);
      if (e.key === 'ArrowLeft') show(li - 1);
    });
    dlg.addEventListener('close', () => go(li, false));
  }

  /* ---------- buy box: tiers, variant, add to cart, sticky bar ---------- */
  function afterAdd(cart, section) {
    const t = window.theme;
    try {
      if (t && t.pubsub && t.pubsub.publish && t.pubsub.PUB_SUB_EVENTS) t.pubsub.publish(t.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'dk-pillow', cart });
    } catch (e) { /* theme without pubsub */ }
    document.dispatchEvent(new CustomEvent('dk:cart:added', { detail: { cart } }));
    const cartType = (t && t.settings && t.settings.cartType) || section.dataset.cartType;
    const drawer = document.querySelector('cart-drawer');
    if (cartType === 'page' || !drawer) {
      window.location.href = root() + 'cart';
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
  }

  // One capture-phase guard for every dk buy box. It runs before handlers that apps bind directly to the buttons
  // (e.g. Rapid Bundle adds its own default offer and stops the event), so the chosen offer card always wins.
  const buyBoxes = new Map();
  let guardOn = false;
  function installGuard() {
    if (guardOn) return;
    guardOn = true;
    window.addEventListener('click', (e) => {
      const btn = e.target && e.target.closest ? e.target.closest('[data-dk-atc], [data-dk-sticky-atc]') : null;
      if (!btn) return;
      const add = buyBoxes.get(btn.closest('[data-dk-main]'));
      if (!add) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!btn.disabled) add();
    }, true);
    window.addEventListener('submit', (e) => {
      const f = e.target;
      if (!f || !f.matches || !f.matches('[data-dk-form]')) return;
      const add = buyBoxes.get(f.closest('[data-dk-main]'));
      if (!add) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      add();
    }, true);
  }

  function initBuy(section) {
    if (section.dataset.dkReady) return;
    section.dataset.dkReady = '1';
    const form = $('[data-dk-form]', section);
    const qtyInput = form && $('[data-dk-qty]', form);
    const idInput = form && $('[data-dk-variant-id]', form);
    const atc = form && $('[data-dk-atc]', form);
    const atcPrice = $('[data-dk-atc-price]', section);
    const err = $('[data-dk-error]', section);
    const fmt = section.dataset.moneyFormat || '';
    const tiers = $$('[data-dk-tier]', section);
    const sticky = $('[data-dk-sticky]', section);
    const sPrice = sticky && $('[data-dk-sticky-price]', sticky);
    const sWas = sticky && $('[data-dk-sticky-was]', sticky);
    const sQty = sticky && $('[data-dk-sticky-qty]', sticky);

    const apply = () => {
      const t = tiers.find((x) => x.checked);
      tiers.forEach((x) => { const l = x.closest('.dk-tier'); if (l) l.classList.toggle('is-on', x === t); });
      if (!t) return;
      const price = +t.dataset.price;
      const was = +t.dataset.was;
      if (qtyInput) qtyInput.value = t.dataset.qty;
      if (atcPrice) atcPrice.textContent = formatMoney(price, fmt);
      if (sPrice) sPrice.textContent = formatMoney(price, fmt);
      if (sWas) { sWas.textContent = formatMoney(was, fmt); sWas.hidden = !(was > price); }
      if (sQty) sQty.textContent = t.dataset.title || '';
    };
    tiers.forEach((t) => t.addEventListener('change', apply));

    const sel = $('[data-dk-variant-select]', section);
    if (sel && idInput) {
      sel.addEventListener('change', () => {
        const o = sel.selectedOptions[0];
        idInput.value = sel.value;
        const u = +o.dataset.price;
        const uw = Math.max(+o.dataset.was || 0, u);
        tiers.forEach((t) => {
          const q = +t.dataset.qty;
          if (t.dataset.fixed !== 'true') t.dataset.price = String(u * q);
          t.dataset.was = String(uw * q);
          const l = t.closest('.dk-tier');
          const p = +t.dataset.price;
          const w = +t.dataset.was;
          const tot = $('[data-dk-total]', l); if (tot) tot.textContent = formatMoney(p, fmt);
          const wEl = $('[data-dk-was]', l); if (wEl) { wEl.textContent = formatMoney(w, fmt); wEl.hidden = !(w > p); }
          const per = $('[data-dk-per]', l); if (per) per.textContent = formatMoney(Math.floor(p / q), fmt);
          const sv = $('[data-dk-save]', l); if (sv) { sv.hidden = !(w > p); const amt = $('[data-dk-save-amt]', sv); if (amt) amt.textContent = formatMoney(w - p, fmt); }
        });
        const up = $('[data-dk-unit-price]', section); if (up) up.textContent = formatMoney(u, fmt);
        const uwEl = $('[data-dk-unit-was]', section); if (uwEl) uwEl.textContent = formatMoney(uw, fmt);
        apply();
      });
    }

    // Keep third-party offer widgets out of this form: they would otherwise rewrite the quantity and add their own line properties.
    const foreign = (n) => n.nodeType === 1 && (/(^|\s)rapi-/.test(n.className || '') || /^properties\[_+rapi/.test(n.getAttribute('name') || '') || /^rapi-/.test(n.getAttribute('name') || '') || n.matches('[data-rapi-id]'));
    const scrub = () => {
      if (!form) return;
      $$('*', form).forEach((n) => { if (foreign(n)) n.remove(); });
      const t = tiers.find((x) => x.checked);
      if (t && qtyInput && qtyInput.value !== t.dataset.qty) qtyInput.value = t.dataset.qty;
      if (t && atcPrice) {
        const want = formatMoney(+t.dataset.price, fmt);
        if (atcPrice.textContent !== want) atcPrice.textContent = want;
      }
    };
    if (form && 'MutationObserver' in window) {
      let rounds = 0;
      const mo = new MutationObserver((records) => {
        if (!records.some((r) => Array.from(r.addedNodes).some(foreign))) return;
        scrub();
        rounds += 1;
        if (rounds > 20) mo.disconnect();
      });
      mo.observe(form, { childList: true, subtree: true });
      setTimeout(scrub, 1500);
      setTimeout(scrub, 4000);
    }

    if (form && atc) {
      const doAdd = async () => {
        if (atc.getAttribute('aria-busy') === 'true' || atc.disabled) return;
        atc.setAttribute('aria-busy', 'true');
        if (err) err.hidden = true;
        scrub();
        const body = new FormData();
        const t = tiers.find((x) => x.checked);
        body.append('id', idInput ? idInput.value : '');
        body.append('quantity', t ? t.dataset.qty : (qtyInput ? qtyInput.value : '1'));
        new FormData(form).forEach((v, k) => { if (/^properties\[(?!_+rapi)/.test(k)) body.append(k, v); });
        try {
          const res = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
          const data = await res.json().catch(() => ({}));
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Das hat leider nicht geklappt. Bitte versuche es noch einmal.');
          const cart = await (await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })).json();
          atc.classList.add('is-added');
          setTimeout(() => atc.classList.remove('is-added'), 1600);
          afterAdd(cart, section);
        } catch (ex) {
          if (err) { err.textContent = ex.message; err.hidden = false; }
        } finally {
          atc.removeAttribute('aria-busy');
        }
      };
      buyBoxes.set(section, doAdd);
      installGuard();
    }

    if (sticky && atc) {
      const btn = $('[data-dk-sticky-atc]', sticky);
      const setOn = (on) => {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (btn) btn.tabIndex = on ? 0 : -1;
        document.documentElement.classList.toggle('dk-sticky-on', on);
      };
      let on = null;
      let ticking = false;
      const check = () => {
        ticking = false;
        const r = atc.getBoundingClientRect();
        const footer = document.querySelector('footer, .footer, [id*="__footer"]');
        const nearEnd = footer ? footer.getBoundingClientRect().top < window.innerHeight * 0.6 : false;
        const next = r.bottom < 0 && !nearEnd;
        if (next !== on) { on = next; setOn(next); }
      };
      window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check, { passive: true });
      check();
    }
    apply();
  }

  /* ---------- delivery estimate + cutoff countdown ---------- */
  function initDelivery(el) {
    if (el.dataset.dkReady) return;
    el.dataset.dkReady = '1';
    const out = $('[data-dk-delivery-text]', el);
    if (!out) return;
    const min = Math.max(0, +el.dataset.min || 0);
    const max = Math.max(+el.dataset.max || 0, min);
    const cutoff = +el.dataset.cutoff || 15;
    const timer = el.dataset.timer === 'true';
    const asDays = el.dataset.style !== 'dates';
    const tplT = ($('[data-dk-tpl-timer]', el) || {}).innerHTML || '';
    const tplP = ($('[data-dk-tpl-plain]', el) || {}).innerHTML || '';
    const WD = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    const work = (d) => d.getDay() !== 0 && d.getDay() !== 6;
    const addWork = (d, n) => { const x = new Date(d); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); if (work(x)) k += 1; } return x; };
    const two = (v) => String(v).padStart(2, '0');
    const day = (d) => `${WD[d.getDay()]}, ${two(d.getDate())}.${two(d.getMonth() + 1)}.`;
    const render = () => {
      const now = new Date();
      const base = new Date(now);
      base.setHours(0, 0, 0, 0);
      if (!(work(now) && now.getHours() < cutoff)) { do { base.setDate(base.getDate() + 1); } while (!work(base)); }
      const from = addWork(base, min);
      const to = addWork(base, max);
      const dates = asDays
        ? `<b>in ${min === max ? min : `${min}–${max}`} Werktag${max === 1 ? '' : 'en'}</b>`
        : (min === max ? `<b>${day(from)}</b>` : `<b>${day(from)} – ${day(to)}</b>`);
      const deadline = new Date(base);
      deadline.setHours(cutoff, 0, 0, 0);
      const ms = deadline - now;
      if (timer && tplT && ms > 0 && ms < 864e5) {
        const t = `<b class="dk-delivery__timer">${two(Math.floor(ms / 36e5))}:${two(Math.floor((ms % 36e5) / 6e4))}:${two(Math.floor((ms % 6e4) / 1e3))}</b>`;
        out.innerHTML = tplT.replace('[timer]', t).replace('[dates]', dates);
      } else {
        out.innerHTML = (tplP || tplT).replace('[timer]', '').replace('[dates]', dates);
      }
    };
    render();
    if (timer) setInterval(render, 1000);
  }

  /* ---------- anatomy stage: cover lifts off, then labels draw in ---------- */
  function initAnat(box) {
    if (box.dataset.dkReady) return;
    box.dataset.dkReady = '1';
    if (reduce || design || !('IntersectionObserver' in window)) { box.classList.add('is-play'); return; }
    const io = new IntersectionObserver((ens) => ens.forEach((en) => {
      if (!en.isIntersecting) return;
      box.classList.add('is-play');
      io.disconnect();
    }), { threshold: 0.35 });
    io.observe(box);
  }

  /* ---------- smooth accordions ---------- */
  function initDetails(d) {
    if (d.dataset.dkReady) return;
    d.dataset.dkReady = '1';
    const summary = d.querySelector('summary');
    const panel = d.querySelector('[data-dk-panel]');
    if (!summary || !panel) return;
    d.classList.toggle('is-open', d.open);
    let anim = null;
    const done = () => { anim = null; panel.style.height = ''; panel.style.opacity = ''; };
    const set = (opening) => {
      if (opening === d.classList.contains('is-open')) return;
      d.classList.toggle('is-open', opening);
      // inside [data-dk-exclusive] only one item stays open
      const group = opening && d.closest('[data-dk-exclusive]');
      if (group) $$('[data-dk-details].is-open', group).forEach((o) => { if (o !== d && o.dkSet) o.dkSet(false); });
      if (reduce || !panel.animate) { d.open = opening; return; }
      const from = anim ? panel.getBoundingClientRect().height : (opening ? 0 : panel.offsetHeight);
      if (anim) anim.cancel();
      if (opening) d.open = true;
      const to = opening ? panel.scrollHeight : 0;
      anim = panel.animate([{ height: from + 'px', opacity: opening ? 0.2 : 1 }, { height: to + 'px', opacity: opening ? 1 : 0 }], { duration: opening ? 380 : 300, easing: 'cubic-bezier(.22, .8, .24, 1)' });
      anim.onfinish = () => { if (!opening) d.open = false; done(); };
      anim.oncancel = () => {};
    };
    d.dkSet = set;
    summary.addEventListener('click', (e) => {
      e.preventDefault();
      set(!d.classList.contains('is-open'));
    });
  }

  /* ---------- featured reviews slider ---------- */
  function initQuotes(box) {
    if (box.dataset.dkReady) return;
    box.dataset.dkReady = '1';
    const track = $('[data-dk-qtrack]', box);
    const slides = track ? $$('[data-dk-qslide]', track) : [];
    if (!slides.length) return;
    const cur = $('[data-dk-qcur]', box);
    const prev = $('[data-dk-qprev]', box);
    const next = $('[data-dk-qnext]', box);
    const step = () => (slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth);
    const index = () => Math.round(track.scrollLeft / Math.max(1, step()));
    const sync = () => {
      const i = Math.min(slides.length - 1, index());
      if (cur) cur.textContent = String(i + 1);
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = atEnd;
    };
    // cut long reviews after a few lines (CSS) and offer "Weiterlesen"
    slides.forEach((slide) => {
      const p = $('.dk-quote__text p', slide);
      if (!p) return;
      const more = document.createElement('button');
      more.type = 'button';
      more.className = 'dk-quote__more';
      more.textContent = 'Weiterlesen';
      more.hidden = true;
      p.parentNode.after(more);
      more.addEventListener('click', () => {
        const open = slide.classList.toggle('is-open');
        more.textContent = open ? 'Weniger anzeigen' : 'Weiterlesen';
      });
      const check = () => { if (!slide.classList.contains('is-open')) more.hidden = p.scrollHeight <= p.clientHeight + 2; };
      check();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
      window.addEventListener('resize', check, { passive: true });
    });
    const go = (d) => track.scrollBy({ left: d * step(), behavior: reduce ? 'auto' : 'smooth' });
    if (prev) prev.addEventListener('click', () => go(-1));
    if (next) next.addEventListener('click', () => go(1));
    let raf = 0;
    track.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  /* ---------- count-up numbers ---------- */
  function initCount(el) {
    if (el.dataset.dkReady) return;
    el.dataset.dkReady = '1';
    const target = parseFloat(el.dataset.dkCount);
    if (!isFinite(target)) return;
    const dec = +(el.dataset.dec || 0);
    const fmt = (v) => v.toLocaleString('de-DE', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    if (reduce || design || !('IntersectionObserver' in window)) { el.textContent = fmt(target); return; }
    el.textContent = fmt(0);
    const io = new IntersectionObserver(([en]) => {
      if (!en.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const dur = 1700;
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / dur);
        el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
        else el.textContent = fmt(target);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    io.observe(el);
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal(scope) {
    const els = $$('[data-dk-reveal]', scope).filter((e) => !e.classList.contains('is-in'));
    if (reduce || design || !('IntersectionObserver' in window)) { els.forEach((e) => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((ens) => ens.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }), { rootMargin: '0px 0px -6% 0px' });
    els.forEach((e) => io.observe(e));
  }

  function init(scope) {
    const s = scope || document;
    $$('[data-dk-gallery]', s).forEach(initGallery);
    $$('[data-dk-main]', s).forEach(initBuy);
    $$('[data-dk-delivery]', s).forEach(initDelivery);
    $$('[data-dk-anat]', s).forEach(initAnat);
    $$('[data-dk-count]', s).forEach(initCount);
    $$('[data-dk-details]', s).forEach(initDetails);
    $$('[data-dk-quotes]', s).forEach(initQuotes);
    initReveal(s);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  window.DKPillow = { formatMoney };
})();
